import React, { useState } from "react";
import styled from "styled-components";
import PrivateHeaderRetailDashboard from "../../../../components/PrivateHeaderRetailDashboard";
import { ENGAGEMENT_TYPES } from "../../../../storage/constants";
import EngagementTypeSelect from "../../reports/reuseableComponents/EngagementTypeSelect";
import HeroLayout from "../layouts/HeroLayout";
import RightConsoleLayout from "../layouts/RightConsoleLayout";
import HomeEngagementChart from "../reuseableComponents/HomeEngagementChart";
import NewMembers from "../reuseableComponents/NewMembers";
import AlertAccordion from "./AlertAccordion";
import AllSubmissionsTable from "./AllSubmissionsTable";
import RightSide from "./RightSide";
import StatBoxes from "./StatBoxes";
import TopPerformersTable from "./TopPerformersTable";
import useGlobalStore from "src/store/useGlobalStore";

const Wrapper = styled.div`
  height: calc(100vh - 64px);
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const PaddingWrap = styled.div`
  padding: 16px;
`;

const getFilteredSubmissions = (submissions, subType) => {
  if (subType === ENGAGEMENT_TYPES.ASSIGNED) {
    return submissions.filter((sub) => sub.assigned);
  }
  if (subType === ENGAGEMENT_TYPES.EXTRACREDIT) {
    return submissions.filter((sub) => !sub.assigned);
  }
  return submissions;
};

const RetailHomepage = ({ config, data }) => {
  const [submissionsType, setSubmissionType] = useState(ENGAGEMENT_TYPES.ALL);
  const setSnackbarText = useGlobalStore((state) => state.setSnackbarText);
  const { current_company: currentCompany } = config;
  const { company_data: companyData, submissions_data: submissionsData } = data;
  const filteredSubmissions = getFilteredSubmissions(
    submissionsData?.recent_submissions,
    submissionsType,
  );

  return (
    <>
      <Wrapper>
        <HeroLayout>
          <PrivateHeaderRetailDashboard>
            <div>
              <EngagementTypeSelect
                engagementType={submissionsType}
                setEngagementType={setSubmissionType}
              />
            </div>
          </PrivateHeaderRetailDashboard>
          <PaddingWrap>
            <StatBoxes
              submissionsType={submissionsType}
              submissionsData={submissionsData}
              companyData={companyData}
            />
          </PaddingWrap>
          <AlertAccordion setSnackbarText={setSnackbarText} />
          <PaddingWrap>
            <HomeEngagementChart
              submissions={filteredSubmissions}
              engagementType={submissionsType}
            />
          </PaddingWrap>
          <PaddingWrap>
            <TopPerformersTable
              submissions={filteredSubmissions}
              submissionsType={submissionsType}
            />
          </PaddingWrap>
          <PaddingWrap>
            <AllSubmissionsTable
              submissions={filteredSubmissions}
              engagementType={submissionsType}
              currentCompanyId={currentCompany?.id}
            />
          </PaddingWrap>
          {companyData?.new_members?.length > 0 && (
            <>
              <PaddingWrap>
                <NewMembers
                  members={companyData?.new_members}
                  isRetailHomepage
                />
              </PaddingWrap>
            </>
          )}
        </HeroLayout>
        <RightConsoleLayout>
          <RightSide data={data} company={currentCompany} config={config} />
        </RightConsoleLayout>
      </Wrapper>
    </>
  );
};

export default RetailHomepage;
